module.exports = __webpack_public_path__ + "static/img/1-2.7940590.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jushuitan/1-2.png
// module id = 1307
// module chunks = 0